




















import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { TipSubjectType } from "@scrile/api-provider/dist/api/TipProvider";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { EVENTS } from "@/const";
import TipController from "@/components/TipController";
import PostTippingModal from "./components/PostTippingModal.vue";

export default defineComponent({
  name: "PostTipping",
  components: { TipController, PostTippingModal },
  props: {
    feedId: { type: String, required: true },
    subjectType: { type: String as PropType<TipSubjectType>, required: false, default: TipSubjectType.CONTENT_SET },
    showNotificationBySuccess: { type: Boolean, required: false, default: false },
  },
  setup(props, { emit }) {
    const tipSubject = computed(() => {
      return { subjectId: props.feedId, subjectType: props.subjectType };
    });

    const success = ref(false);

    const setSuccess = () => {
      if (props.showNotificationBySuccess) {
        emitter.emit(EVENTS.NOTIFICATION_SHOW, { text: $t("Tip sent, thank you!"), position: "top", timeout: 1500 });
        emit("close");
      }
      success.value = true;
    };
    return {
      tipSubject,
      success,
      setSuccess,
    };
  },
});
